import { http } from './http';
import type { ReportType, GetReportResponse } from '@daynote/shared-types';

export const reportApi = {
  get: (type: ReportType, date: string) =>
    http.get<unknown, GetReportResponse>('/reports', { params: { type, date } }),
};
